if(!customElements.get("product-image-slider")) {
  customElements.define("product-image-slider", class ProductImageSlider extends HTMLElement {
    constructor() {
      super();

      this.thumbnailSlider = this.querySelector(".thumbnail-slider");
      this.thumbnails = this.querySelectorAll(".thumb-slide .thumbnail");
      this.mediaWrapper = this.querySelector(".product-media--wrapper");

      this.initSlider();
    }

    initSlider() {
      // initialize the slider
      $('.thumbnail-slider').slick({
        vertical: true,
        slidesToShow: 4,
        nextArrow: '.thumbnail-slider__next',
        prevArrow: '.thumbnail-slider__prev'
      });
      this.thumbnails = this.querySelectorAll(".thumb-slide .thumbnail");

      this.thumbnailZoom();

      // initialize thumbnail click interaction
      this.thumbnails.forEach(thumbnail => {
        thumbnail.addEventListener("click", (event) => {
          this.thumbnailSwitch(event, thumbnail)
        });
      });
    }

    // initiate zoom feature
    thumbnailZoom() {
      $("#prodImg").ezPlus({
        gallery : "thumbGallery",
        galleryActiveClass: "active",
        zoomType:'inner',
        scrollZoom: false,
        responsive: true,
        zoomWindowFadeIn: 500,
        zoomWindowFadeOut: 750
      });
    }

    thumbnailSwitch(event, thumbnail) {
      event.preventDefault();
      // thumbnail elements
      const activeThumbnail = this.querySelector(".thumb-slide.slick-current");
      const currentThumbnail = thumbnail.closest(".thumb-slide");

      // video and image containers
      const imageCont = this.mediaWrapper.querySelector(".main-image__container");
      const videoCont = this.mediaWrapper.querySelector(".main-video__container");
      const zoomContainer = document.querySelector(".zoomContainer");
      const videoElm = videoCont.querySelector("video");
      const videoSrcElm = videoCont.querySelector("source");
      const imageElm = imageCont.querySelector("img");

      if(activeThumbnail !== currentThumbnail) {
        activeThumbnail.classList.remove("slick-current");
        currentThumbnail.classList.add("slick-current");

        // video thumbnail
        if(thumbnail.classList.contains("thumbnail-exclusive")) {
          const videoUrl = thumbnail.dataset.video;
          const videoType = thumbnail.dataset.videoFormat;

          videoSrcElm.src = videoUrl;
          videoSrcElm.setAttribute("type", `video/${videoType}`);
          videoElm.load();
          videoElm.play();

          imageCont.style.display = "none";
          zoomContainer.style.display = "none";
          videoCont.style.display = "block";
        }
        // image thumbnail
        else {
          const imageUrl = thumbnail.dataset.imageUrl;

          // imageElm.setAttribute("src", imageUrl);

          imageCont.style.display = "block";
          zoomContainer.style.display = "block";
          videoCont.style.display = "none";
        }
      }
    }
  });
}

if(!customElements.get("mobile-image-slider")) {
  customElements.define("mobile-image-slider", class MobileImageSlider extends HTMLElement {
    constructor() {
      super();

      this.initSlider();
    }

    initSlider() {
      $(".thumbnail-slider--mob").slick({
        vertical: false,
        slidesToShow: 1,
        nextArrow: '.nextArrow-slider',
        prevArrow: '.prevArrow-slider'
      })
    }
  });
}
